import config from '../config';
import http from '../utils/http';
import { interpolate } from '../utils/string';

/**
 *
 * @param {Object} filters
 * @returns {Array} data
 */
export const fetchShippings = async (filters) => {
  const { data } = await http.get(config.apiEndPoint.shipping.fetchShippings, {
    params: {
      ...filters,
    },
  });
  return data.data;
};

/**
 *
 * @param {Integer} id
 * @returns {Object} data
 */
export const fetchShipping = async (id) => {
  const url = interpolate(config.apiEndPoint.shipping.fetchShipping, { id: id });

  const { data } = await http.get(url);

  return data.data;
};

/**
 *
 * @param {Integer} id
 * @returns {Object} data
 */

/**
 *
 * @param {Integer} id
 * @returns {Object} data
 */


/**
 *
 * @param {Integer} id
 * @returns {Object} data
 */
export const deleteShipping = async (id) => {
  const url = interpolate(config.apiEndPoint.shipping.deleteShipping, {
    id: id,
  });
  const { data } = await http.remove(url, {
    accessToken: true,
  });

  return data;
};

/**
 *
 * @param {Object} body
 * @returns {Object} data
 */
export const createShipping = async (body) => {
  const { data } = await http.post(config.apiEndPoint.shipping.createShipping, {
    body,
    accessToken: true,
  });

  return data;
};

/**
 *
 * @param {Integer} id
 * @returns {Object} data
 */
export const updateShipping = async (id, body) => {
  const url = interpolate(config.apiEndPoint.shipping.updateShipping, {
    id: id,
  });
  const { data } = await http.put(url, {
    body,
    accessToken: true,
  });

  return data;
};

/**
 *
 * @param {Object} filters
 */
export const filterParams = (filters) => {
  Object.keys(filters).forEach((key) => {
    if (filters.hasOwnProperty(key)) {
      if (filters[key] === '') {
        delete filters[key];
      }
    }
  });
};
